import BaseController from './BaseController'
import Scrollbar from 'smooth-scrollbar'

export default class SingleEventController extends BaseController {

  init() {
    // this.initScrollbar()
    // this.revealAnimate()
    // this.listeners()
    // this.openings()
    // this.contact()


    this.playButton = document.querySelector('.button-play');
    this.video = document.querySelector('.video-article');
    this.videoButton = document.querySelector('.js-trigger-player');
    this.symboleButton = document.querySelector('.symbole');
    this.slider();
    this.player();
    this.$dones = [];
  }

  listeners() {
    // this.scrollbar.addListener(() => { this._handleReveals() })
  }


  slider() {
    $(document).ready(function () {
      $('.slider-gallery__slides').slick({
        infinite: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        mobileFirst: true,
        variableWidth: true,
        appendArrows: '.slider-gallery__arrows-wrapper',
      })
    });
  }

  player() {
    if (window.innerWidth > 1300) {
      this.playButton.addEventListener('click', () => {
        if (this.video.paused === true) {
          this.video.play();

          this.symboleButton.classList.remove("triangle");
          this.symboleButton.classList.add("pause");
          this.playButton.classList.add("isHide");

        } else {
          this.video.pause();

          this.symboleButton.classList.remove("pause");
          this.symboleButton.classList.add("triangle");
        }
      })

      this.videoButton.addEventListener('mouseenter', () => {
        this.playButton.classList.remove("isHide");

        if (this.video.ended) {
          this.symboleButton.classList.remove("pause");
          this.symboleButton.classList.add("triangle");
        }
      })

      this.videoButton.addEventListener('mouseleave', () => {
        if (this.symboleButton.classList.contains('triangle')) return
        this.playButton.classList.add("isHide");
      })

    } else {
      this.videoButton.addEventListener('click', () => {
        if (this.video.paused === true) {
          this.video.play();
          this.playButton.classList.add("isHide");
        } else {
          this.video.pause()
          this.playButton.classList.remove("isHide");
        }
      })
    }
  }
}